export enum ContactInquiryType {
  SUBMIT_DAPP = 'submitDapp',
  REPORT_BUG = 'reportBug',
  REQUEST_FEATURE = 'requestFeature',
  SUBMIT_FEEDBACK = 'submitFeedback',
  GENERAL_INQUIRY = 'generalInquiry',
}
